import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { usePermissions } from '../../hooks/usePermissions'
import { shouldUseNewPermissions } from '../../utils/devMode'
import {
  canAccessRoute,
  isAuthenticated,
} from '../../utils/permissionsManager'

const ProtectedRoute = ({
  children,
  requiredPermission,
  fallbackPath = '/admin/noAccess',
  showFallback = true,
}) => {
  const { hasPermission, userRole } = usePermissions()
  const location = useLocation()
  const useNewPermissions = shouldUseNewPermissions()

  // Если новая система прав отключена, разрешаем доступ
  if (!useNewPermissions) {
    return children
  }

  // Проверяем авторизацию
  if (!isAuthenticated()) {
    return (
      <Navigate
        to='/auth'
        state={{ from: location }}
        replace
      />
    )
  }

  // Если нет требуемого права, показываем fallback
  if (
    requiredPermission &&
    !canAccessRoute(requiredPermission)
  ) {
    if (showFallback) {
      return (
        <Navigate
          to={fallbackPath}
          state={{ from: location }}
          replace
        />
      )
    }
    return null
  }

  return children
}

export default ProtectedRoute
